module.exports = __webpack_public_path__ + "static/media/Standee_05_4X6.7623695f.jpg";